// We cannot use IntegrationSessionLink here since it will trigger tons of calls to get IntegrationSessionLink
// Therefore, in session list, it will leads to performance issues
// TODO: Needs to properly handle IntegrationSessionLink call in the future to bring it back
export function isSessionPatientLinkingReadOnly({
  ehr_appt_id,
  isFhirAuth = false,
}: {
  ehr_appt_id?: string | null;
  isFhirAuth?: boolean;
}): boolean {
  return Boolean(isFhirAuth || ehr_appt_id);
}
